// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__J2Ne5","colMin":"styles_colMin__1RLNb"};